import React, { useState } from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Users, UserCheck } from 'lucide-react';

export default function StudentAssignment({ students = [], selectedStudents, setSelectedStudents, label = "Asignar a Estudiantes" }) {
  const [showSelector, setShowSelector] = useState(false);

  const toggleStudent = (studentId) => {
    setSelectedStudents(prev =>
      prev.includes(studentId)
        ? prev.filter(id => id !== studentId)
        : [...prev, studentId]
    );
  };

  const selectAll = () => {
    setSelectedStudents(students.map(s => s.id || s.user_id));
  };

  const deselectAll = () => {
    setSelectedStudents([]);
  };

  if (students.length === 0) return null;

  return (
    <div className="bg-indigo-50 border border-indigo-200 rounded-xl p-4">
      <div className="flex items-center justify-between mb-3">
        <label className="text-sm font-bold text-slate-700 flex items-center gap-1.5">
          <Users className="w-4 h-4 text-indigo-500" /> {label}
        </label>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => setShowSelector(!showSelector)}
          className="text-xs"
        >
          {showSelector ? 'Ocultar' : 'Mostrar'} lista
        </Button>
      </div>

      {/* Summary */}
      <div className="flex items-center gap-2 mb-2">
        {selectedStudents.length === 0 ? (
          <Badge variant="secondary" className="text-xs">Todos los estudiantes verán este contenido</Badge>
        ) : (
          <Badge className="bg-indigo-100 text-indigo-700 text-xs">
            <UserCheck className="w-3 h-3 mr-1" />
            {selectedStudents.length} estudiante(s) seleccionado(s)
          </Badge>
        )}
      </div>

      {/* Student List */}
      {showSelector && (
        <div className="mt-3 space-y-2">
          <div className="flex gap-2 mb-2">
            <button
              type="button"
              onClick={selectAll}
              className="text-xs text-indigo-600 hover:underline"
            >
              Seleccionar todos
            </button>
            <span className="text-slate-300">|</span>
            <button
              type="button"
              onClick={deselectAll}
              className="text-xs text-slate-500 hover:underline"
            >
              Deseleccionar todos
            </button>
          </div>
          <div className="max-h-40 overflow-y-auto border rounded-lg p-2 bg-white space-y-1">
            {students.map(student => {
              const studentId = student.id || student.user_id;
              const studentName = student.first_name 
                ? `${student.first_name} ${student.last_name}` 
                : student.username;
              return (
                <label
                  key={studentId}
                  className="flex items-center gap-2 cursor-pointer hover:bg-slate-50 p-1.5 rounded text-sm"
                >
                  <Checkbox
                    checked={selectedStudents.includes(studentId)}
                    onCheckedChange={() => toggleStudent(studentId)}
                  />
                  <span>{studentName}</span>
                </label>
              );
            })}
          </div>
          <p className="text-xs text-slate-400 mt-1">
            * Si no seleccionas ningún estudiante, el contenido será visible para todos
          </p>
        </div>
      )}
    </div>
  );
}
